<template>
  <layout-main-inner :title="$route.query.deliveryAddressId ? '编辑经销商收货方' : '新增经销商收货方'">
    <template slot="action">
      <el-button
        v-if="$route.query.deliveryAddressId"
        type="primary"
        :loading="loading"
        @click="update">更新</el-button>
      <el-button
        v-else
        type="primary"
        :loading="loading"
        @click="create">保存</el-button>
    </template>
    <el-form
      ref="ruleForm"
      :model="delivery"
      :rules="rules"
      label-position="top">
      <layout-card-wrap
        v-loading="loading"
        hasHeaderSlot>
        <template slot="title">基本信息</template>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              label="收货方名称:"
              prop="deliveryName">
              <el-input v-model="delivery.deliveryName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="联系电话:"
              prop="deliveryPhone">
              <el-input v-model="delivery.deliveryPhone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="省市(地区)区(县):"
              prop="area">
              <area-select v-model="delivery.area" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="详细地址:"
              prop="detailedAddress">
              <el-input v-model="delivery.detailedAddress"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item
              label="销售区域(H5展示):"
              prop="saleAreaName">
              <el-input v-model="delivery.saleAreaName"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <el-form-item
              label="销售区域:"
              prop="saleAreas">
              <checkbox-tree
                ref="area"
                v-model="delivery.saleAreas"
                :treeData="cityTree"
                nodeKey="areaCode"
                :expandAll="false"
                :defaultProps="defaultProps" />
            </el-form-item>
          </el-col>
        </el-row>
      </layout-card-wrap>
    </el-form>
  </layout-main-inner>
</template>

<script>
import AreaSelect from './busi/area-select.vue'
import CheckboxTree from '@/components/public/checkbox-tree.vue'
import _ from 'lodash'
export default {
  name: 'DeliveryEdit',
  components: { AreaSelect, CheckboxTree },
  props: {},
  data() {
    return {
      loading: false,
      defaultProps: {
        children: 'children',
        label: 'areaName'
      },
      rules: {
        deliveryName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' },
          { max: 30, message: '长度最大 30 个字符', trigger: 'blur' }
        ],
        deliveryPhone: [
          { pattern: /^1[0-9][0-9]\d{8}$/, required: true, message: '请输入正确的联系电话', trigger: 'blur' }
        ],
        area: [
          { required: true, message: '请选择省市(地区)区(县)', trigger: 'blur' }
        ],
        detailedAddress: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        saleAreaName: [
          { required: false, message: '请输入销售区域', trigger: 'blur' }
        ],
        saleAreas: [
          { required: true, message: '请选择销售区域', trigger: 'blur' }
        ]
      },
      delivery: {
        area: [],
        saleAreas: []
      },
      cityTree: []
    }
  },
  mounted() {
    if (this.$route.query.deliveryAddressId) {
      this.getdeliveryaddress()
    } else {
      this.getcitytree()
    }
  },
  methods: {
    create() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          const saleAreas = _.cloneDeep(this.$refs.area.getCheckedNodes())
          const province = []
          saleAreas.forEach(item => {
            if (item.level === 1) {
              province.push(item.provinceCode)
            }
          })
          _.remove(saleAreas, item => item.level === 2 && province.indexOf(item.provinceCode) > -1)
          console.log(saleAreas)
          const { deliveryName, deliveryPhone, detailedAddress, saleAreaName, area } = this.delivery
          this.$store.dispatch('delivery/adddeliveryaddress', {
            payload: {
              customerId: this.$route.query.customerId,
              vendorId: this.$route.query.vendorId,
              deliveryName,
              deliveryPhone,
              detailedAddress,
              saleAreaName,
              provinceCode: area[0],
              cityCode: area[1],
              areaCode: area[2],
              saleAreas: saleAreas.map(item => ({ provinceCode: item.provinceCode, cityCode: item.cityCode }))
            },
            success: () => {
              this.loading = false
              this.$router.go(-1)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    update() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          const saleAreas = _.cloneDeep(this.$refs.area.getCheckedNodes())
          const province = []
          saleAreas.forEach(item => {
            if (item.level === 1) {
              province.push(item.provinceCode)
            }
          })
          _.remove(saleAreas, item => item.level === 2 && province.indexOf(item.provinceCode) > -1)
          console.log(saleAreas)
          const { deliveryName, deliveryPhone, detailedAddress, saleAreaName, area } = this.delivery
          this.$store.dispatch('delivery/updatedeliveryaddress', {
            payload: {
              vendorId: this.$route.query.vendorId,
              deliveryAddressId: this.$route.query.deliveryAddressId,
              deliveryName,
              deliveryPhone,
              detailedAddress,
              saleAreaName,
              provinceCode: area[0],
              cityCode: area[1],
              areaCode: area[2],
              saleAreas: saleAreas.map(item => ({ provinceCode: item.provinceCode, cityCode: item.cityCode }))
            },
            success: () => {
              this.loading = false
              this.$router.go(-1)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    getdeliveryaddress() {
      this.loading = true
      this.$store.dispatch('delivery/getdeliveryaddress', {
        payload: {
          vendorId: this.$route.query.vendorId,
          deliveryAddressId: this.$route.query.deliveryAddressId
        },
        success: (res) => {
          this.delivery = {
            ...this.delivery,
            ...res.data,
            area: [res.data.provinceCode, res.data.cityCode, res.data.areaCode],
            saleAreas: res.data.saleAreas.map(item => item.cityCode || item.provinceCode)
          }
          this.loading = false
          this.getcitytree()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getcitytree() {
      this.loading = true
      this.$store.dispatch('delivery/getcitytree', {
        payload: {},
        success: (res) => {
          res.data.areaNodes.forEach(i => {
            i.provinceCode = i.areaCode
            i.children.forEach(s => {
              s.provinceCode = i.areaCode
              s.cityCode = s.areaCode
            })
          })
          this.cityTree = res.data.areaNodes
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped></style>
